import { Component, OnInit, Input } from "@angular/core";
import {
  ModalController,
  ToastController,
  LoadingController,
} from "@ionic/angular";
import { TransactionsService } from "src/app/api/transactions.service";

import { EmailComposer } from "@ionic-native/email-composer/ngx";
import { AppSettings } from "src/app/app-settings";
import { CallNumber } from "@ionic-native/call-number/ngx";

@Component({
  selector: "app-details",
  templateUrl: "./details.page.html",
  styleUrls: ["./details.page.scss"],
})
export class DetailsPage implements OnInit {
  @Input() transactionId: string;

  private loading: boolean;

  public reference: string;
  public quantity: number;
  public price: number;
  public seller: string;
  public company: string;
  public manufacturer: string;
  public condition: string;
  public comments: string;
  public phone: string;
  public email: string;
  public email_body: string;
  public email_subject: string;
  public date: Date;
  public transaction_type: string;
  public transaction_mailing: string;

  isWeb = AppSettings.IS_WEB;

  constructor(
    private modalCtrl: ModalController,
    private transactionService: TransactionsService,
    private callNumber: CallNumber,
    private emailComposer: EmailComposer,
    private toastCtrl: ToastController,
    private loadingCtrl: LoadingController
  ) {}

  ngOnInit() {}

  async ionViewWillEnter() {
    const loadingElement = await this.loadingCtrl.create({
      message: "Please wait...",
      spinner: "crescent",
    });
    loadingElement.present();

    this.transactionService
      .details(this.transactionId)
      .then((response) => {
        this.transaction_mailing = response["transaction_mailing"];
        this.transaction_type = response["transaction_type"];
        this.reference = response["transaction_reference"];
        this.quantity = response["quantity"];
        this.price = response["price"];
        this.seller = response["fullname"];
        this.company = response["company_name"];
        this.manufacturer = response["manufacturer"];
        this.condition = response["condition"];
        this.comments = response["comment"];
        this.phone = response["phone"];
        this.email = response["email"];
        this.email_body = response["email_body"];
        this.email_subject = response["email_subject"];
        this.date = new Date(response["created_at"]);
        loadingElement.dismiss();
      })
      .catch((err) => {
        loadingElement.dismiss();
        this.closeDetailsModal();
      });
  }

  closeDetailsModal() {
    this.modalCtrl.dismiss(null);
  }

  async call() {
    this.closeDetailsModal();
    if (!this.isWeb) {
      this.callNumber.callNumber(this.phone, true);
    } else {
      let selBox = document.createElement("textarea");
      selBox.style.position = "fixed";
      selBox.style.left = "0";
      selBox.style.top = "0";
      selBox.style.opacity = "0";
      selBox.value = this.phone;
      document.body.appendChild(selBox);
      selBox.focus();
      selBox.select();
      document.execCommand("copy");
      document.body.removeChild(selBox);

      this.toastCtrl.dismiss().catch(() => {});
      let toast = await this.toastCtrl.create({
        message: "Phone number copied to clipboard",
        duration: 1000,
        position: "bottom",
        showCloseButton: true,
        color: "light",
      });
      toast.present();
    }
  }

  compose() {
    // Send a text message using default options
    this.closeDetailsModal();
    if (!this.isWeb) {
      this.emailComposer.open({
        to: this.email,
        subject: this.email_subject,
        body: this.email_body,
      });
    } else {
      let mail = document.createElement("a");
      mail.href = `mailto:${this.email}?subject=${
        this.email_subject
      }&body=${encodeURI(this.email_body)}`;
      mail.click();
    }
  }
}
